module.exports = {"id":"237075","name":"Christian Ramirez","rating":"71","photo":"./data/images/photos/2/237075.png","club":{"name":"Minnesota United FC","logo":"./data/images/clubs/MinnesotaUnitedFC.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristianRamirez0.json
// module id = 801
// module chunks = 0